import React, { Fragment } from 'react';
import { Box, CircularProgress } from '@mui/material';
import useFetchData from '../../shared/hooks/use-fetch-data';

import CustomerList from '../components/CustomerList';

const Customers = () => {
  const { data, loading } = useFetchData({
    method: 'get',
    url: 'customers'
  });

  return (
    <Fragment>
      {loading && (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: 300 }}>
          <CircularProgress sx={{ color: '#0d9488' }} />
        </Box>
      )}
      {!loading && <CustomerList items={data} />}
    </Fragment>
  );
};

export default Customers;
